export function overdueTasksCountCopy(count: number) {
  if (count > 1) return `${count} tasks are overdue`;
  return `${count} task is overdue`;
}

export function dueSoonTasksCountCopy(count: number) {
  if (count > 1) return `${count} tasks are due soon`;
  return `${count} task is due soon`;
}
